<template>
	<div>
		<v-badge
			:color="hasArticles ? 'orange' : 'transparent'"
			overlap
			:content="articles.length"
			:class="['animate__animated', { animate__tada: ui.animate }]"
		>
			<v-btn
				fab
				color="#1976D2"
				elevation="0"
				:small="$vuetify.breakpoint.mdAndUp"
				title="Ver carrito de compra"
				@click="toggle()"
			>
				<v-icon class="white--text">
					mdi-cart
				</v-icon>
			</v-btn>
		</v-badge>

		<!-- <v-card class="cart-content" elevation="15" v-show="ui.show">
			<v-card-title
				class="black--text d-flex justify-space-between align-center"
			>
				<div class="d-flex align-center">
					Carrito de compra
				</div>

				<v-btn
					color="primary"
					small
					:large="$vuetify.breakpoint.smAndDown"
					dark
					class="ma-0"
					@click="CartShow()"
				>
					Ver todo
				</v-btn>
			</v-card-title>
			<v-card-text class="black--text cart-items-container pa-0">
				<template v-if="articles.length == 0">
					<v-row style="height: 100%;">
						<v-col
							cols="12"
							class=" d-flex justify-center align-center flex-column"
							style="height: 100%;"
						>
							Su carrito de compra está vacío
						</v-col>
					</v-row>
				</template>

				<template v-else>
					<div
						v-for="(article, key) in articles"
						class="item-container"
						@click="CartShow()"
					>
						<div class="d-flex flex-column item-details">
							<div class="d-flex align-center">
								<v-avatar size="20" color="#ddd" class="mr-2">
									{{ key + 1 }}
								</v-avatar>

								<small>
									{{
										`${article.code} - ${article.description}`
									}}
								</small>
							</div>
							<div class="d-flex justify-start">
								<span>
									<strong>Cantidad:</strong>
									{{ article.amount }}
								</span>

								<span class="ml-4">
									<strong>P.U:</strong>
									{{ `${priceFormat(article.price)} MXN` }}
								</span>
							</div>
						</div>

						<div class="main-image-container">
							<template v-if="mainImage(article)">
								<img :src="mainImage(article)" alt="" />
							</template>

							<template v-else>
								<div class="no-image no-image-small"></div>
							</template>
						</div>
					</div>
				</template>
			</v-card-text>
			<v-card-actions
				:class="[
					'd-flex',
					'pa-4',
					$vuetify.breakpoint.mdAndUp
						? 'justify-end'
						: 'justify-center',
				]"
			>
				<template v-if="articles.length > 0">
					<strong>Total: {{ `${Total} MXN` }}</strong>
				</template>
			</v-card-actions>
		</v-card> -->
	</div>
</template>

<script>
import { EventBus } from "@/main";
import Article from "@/clas/Article";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
	name: "Cart",

	data() {
		return {
			ui: {
				show: false,

				animate: false,
			},
		};
	},

	created() {
		EventBus.$on("ArticleAdded", () => {
			this.ui.animate = true;
			setTimeout(() => {
				this.ui.animate = false;
			}, 1000);
		});
	},

	methods: {
		CartShow() {
			this.ui.show = false;

			if (this.$route.name != "CartShow") {
				this.$router.push({ name: "CartShow" });
			}
		},

		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		mainImage(article) {
			let a = new Article(article);

			return a.mainImage();
		},

		toggle() {
			this.ui.show = !this.ui.show;

			EventBus.$emit("CartTypePanelToggle");
		},
	},

	computed: {
		...mapGetters({
			getArticles: "cart/getArticles",
			getTotal: "cart/getTotal",
		}),

		articles() {
			return this.getArticles;
		},

		Total() {
			return this.priceFormat(this.getTotal);
		},

		hasArticles() {
			return this.articles.length > 0 ? true : false;
		},
	},
};
</script>

<style lang="css" scoped>
.cart-content {
	position: absolute;
	width: 450px;
	right: 100px;
	top: 80px;
}

.cart-content::after {
	content: "";
	position: absolute;
	top: -20px;
	right: 10px;
	border-top: 10px solid transparent;
	border-bottom: 10px solid #fff;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
}

.cart-items-container {
	overflow-y: scroll;
	overflow-x: hidden;
	height: 425px;
	border-top: 2px solid #eee;

	display: flex;
	flex-direction: column-reverse;
	justify-content: flex-end;
}

.item-container {
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 75px;
	border-bottom: 1px solid #eee;
	font-size: 13px;
	padding: 5px 15px;
}
.item-container:hover {
	background: linear-gradient(
		90deg,
		rgba(0, 0, 0, 0.15) 0%,
		rgba(0, 0, 0, 0) 75%
	);
}

.item-details {
	width: calc(100% - 70px);
	border-right: 1px solid #ddd;
}

.main-image-container {
	height: 100%;
	width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.main-image-container img {
	height: 90%;
	max-width: 100%;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.cart-content {
		position: absolute;
		width: 100%;
		right: 0;
	}

	.cart-content::after {
		content: "";
		position: absolute;
		top: -20px;
		right: 20px;
		border-top: 10px solid transparent;
		border-bottom: 10px solid #fff;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
	}

	.cart-items-container {
		height: 73vh;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.cart-content {
		right: 10px;
	}
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
}
</style>
